// Main.js file.
(function ($) {
  Drupal.behaviors.thomaspironMain = {
      attach: function (context, settings) {


        //Open and Close menu

        $('#block-thomaspiron-main-menu').click(function(e){
          e.stopPropagation();
        });
        $('.menu-button', context).click(function (e) {
          e.preventDefault();
          e.stopPropagation();
          $('#block-thomaspiron-main-menu').addClass('menu-active');
        });
        $('.close-menu').click(function () {
          $('#block-thomaspiron-main-menu').removeClass('menu-active');
        })

        $(document).click(function() {
          $('#block-thomaspiron-main-menu').removeClass('menu-active');
        });


        // Slide toggle menu items
        $('#block-thomaspiron-main-menu >ul > .menu-item--expanded').each(function () {
          if($(this).find('>span').length >0) {
            $(this).addClass('no-link');
          }else {
            $(this).append('<span class="menu-toggle"></span>');

          }
        });
        // if(!$('#block-thomaspiron-main-menu >ul > .menu-item--expanded >span').length > 0) {
        //   $('#block-thomaspiron-main-menu >ul > .menu-item--expanded',context).append('<span class="menu-toggle"></span>');
        // }



        $('#block-thomaspiron-main-menu >ul > .menu-item--expanded .menu-toggle',context).click(function (e) {
          e.stopPropagation();
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded >.menu').not($(this).parent().find('>.menu')).stop(true,true).slideUp();
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded .menu-toggle').not(this).removeClass('is-open');
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded span:not(.menu-toggle)').removeClass('is-open');

          $(this).parent().find('>.menu').stop(true, true).slideToggle();
          $(this).toggleClass('is-open');

        });

        $('#block-thomaspiron-main-menu >ul > .menu-item--expanded >span:not(.menu-toggle)',context).click(function (e) {
          e.stopPropagation();
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded >.menu').not($(this).parent().find('>.menu')).stop(true,true).slideUp();
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded span:not(.menu-toggle)').not(this).removeClass('is-open');
          $('#block-thomaspiron-main-menu >ul > .menu-item--expanded .menu-toggle').removeClass('is-open');

          $(this).parent().find('>.menu').stop(true, true).slideToggle();
          $(this).toggleClass('is-open');


        });

        //Third level menu

        $('#block-thomaspiron-main-menu >ul > .menu-item--expanded > ul > .menu-item--expanded >span',context).click(function (e) {
          e.stopPropagation();
          $(this).parent().find('>ul').slideToggle();
          $(this).toggleClass('is-open');
        })

        $('#block-thomaspiron-main-menu >ul > .menu-item--expanded >span:not(.menu-toggle)',context)

        //Search block
        let search_placeholder = Drupal.t('Search');
        $('.search-block-form input[type="search"]').attr('placeholder',search_placeholder);


        //Homepage slide

        $('.field--name-field-page-hero').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        });


        var project_slider_thumbs;
        if($('.project-slider-thumbs').length >0) {
          project_slider_thumbs = '.project-slider-thumbs'
        }else {
          project_slider_thumbs = false;
        }
        $('.project-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          asNavFor: project_slider_thumbs,
        });

        $('.project-slider-thumbs').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          infinite: false,
          // arrows: false,
          asNavFor: '.project-slider',
          dots: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                // infinite: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows:false
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });

        var content_slider_thumbs;
        if($('.content-slider-thumbs').length >0) {
          content_slider_thumbs = '.content-slider-thumbs'
        }else {
          content_slider_thumbs = false;
        }

        $('.page-content--slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          asNavFor: content_slider_thumbs,
        });

        $('.page-content--thumbs').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          variableWidth: true,
          // infinite: false,
          // arrows: false,
          asNavFor: '.page-content--slider',
          dots: false,
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,

              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,

              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });

        //Nos Realisations slider
        $('.nos-realisations--slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        });

        let showhouse_thumbs = $('.showhouse_images .item-list:first-child ul');
        var showhouse_slider_thumbs;
        if($('.showhouse_images .item-list:nth-child(2) ul').length >0) {
          showhouse_slider_thumbs = '.showhouse_images .item-list:nth-child(2) ul'
        }else {
          showhouse_slider_thumbs = false;
        }
        //Showhouse
        $('.showhouse_images .item-list:first-child ul').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          asNavFor: showhouse_slider_thumbs,
        });
        $('.showhouse_images .item-list:nth-child(2) ul').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          // arrows: false,
          asNavFor: showhouse_thumbs,
          dots: false,
          focusOnSelect: true
        });
        // Remove active class from all thumbnail slides
        $('.showhouse_images .item-list:nth-child(2) ul .slick-slide').removeClass('slick-active');

        // Set active class to first thumbnail slides
        $('.showhouse_images .item-list:nth-child(2) ul .slick-slide').eq(0).addClass('slick-active');

        // On before slide change match active thumbnail to current slide
        $('.showhouse_images .item-list:first-child ul').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var mySlideNumber = nextSlide;
          $('.showhouse_images .item-list:nth-child(2) ul .slick-slide').removeClass('slick-active');
          $('.showhouse_images .item-list:nth-child(2) ul .slick-slide').eq(mySlideNumber).addClass('slick-active');
        });





        // Remove active class from all thumbnail slides
        $('.project-slider-thumbs .slick-slide').removeClass('slick-active');

        // Set active class to first thumbnail slides
        $('.project-slider-thumbs .slick-slide').eq(0).addClass('slick-active');

        // On before slide change match active thumbnail to current slide
        $('.project-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          var mySlideNumber = nextSlide;
          $('.project-slider-thumbs .slick-slide').removeClass('slick-active');
          $('.project-slider-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
        });

        // Drupal.behaviors.thomaspironMain = {
        //   attach: function (context, settings) {

          var map = $(context).find('.geolocation-map-container');
          var map_wrapper = $(context).find('#block-showhouse-map .view-content');

          map.css('opacity', 0);
          map_wrapper.css('transition', 'none');
          map_wrapper.css('width', '491px');
          map_wrapper.css('height', '361px');
          map_wrapper.css('background', 'url("/themes/custom/thomaspiron/assets/svg/throbber.svg") no-repeat center');

          $.ajax({
            success: function () {
              map.css('opacity', 1);
              map_wrapper.css('background', 'transparent');


              var select_element_none = 0;
              const select_element_value = [];
              $(context).find('#views-exposed-form-showhouse-page-1 .js-form-type-radio').each(function (i, item) {
                if ($(this).find('input').val() === 'All' && $(this).find('input').prop('checked')) {
                  select_element_none = select_element_none + 1;
                } else if ($(this).find('input').val() !== 'All') {
                  select_element_value[i] = $(this).find('input');
                }
              });
              if (select_element_none === 2) {
                select_element_value[1].click();
              }

              // Add actions for pins.
              $('#block-showhouse-map div[title]').each(function () {

                // Select filter on click.
                $(this).on('click', function () {
                  $(context).find('#views-exposed-form-showhouse-page-1 input[value=' + ($(this).attr('title')) + ']').trigger('click');
                });
                // On hover.
                $(this).mouseenter(function () {
                  $(this).css('background', '#df2f17').css('border-radius', '50%');
                  $(context).find('#views-exposed-form-showhouse-page-1 input[value=' + ($(this).attr('title')) + ']').parent().css('color', '#df2f17');
                });
                // On hover out.
                $(this).mouseleave(function () {
                  if (!$(context).find('#views-exposed-form-showhouse-page-1 input[value=' + ($(this).attr('title')) + ']').is(':checked')) {
                    $(this).css('background', '');
                    $(context).find('#views-exposed-form-showhouse-page-1 input[value=' + ($(this).attr('title')) + ']').parent().css('color', '');
                  }
                });
              });

              // Add actions for filters.
              $(context).find('#views-exposed-form-showhouse-page-1 .js-form-type-radio').each(function () {
                // If filter is selected.
                if ($(this).find('input').is(':checked')) {
                  if ($(this).find('input').val() !== 'All') {
                    var selected_val = $(this).find('input').val();
                    var label = $(this).find('label').html();
                    $('#block-showhouse-map div[title]').each(function () {
                      $(this).css('background', '');
                      $(this).find('.pin-description').remove();
                    });
                    var selected_pin = $('#block-showhouse-map div[title=' + selected_val + ']');
                    selected_pin.css('background', '#df2f17').css('border-radius', '50%').css('display', 'flex').css('flex-wrap', 'wrap');
                    selected_pin.css('overflow', 'unset');
                    selected_pin.append('<span class="pin-description">' + label + '</span>');
                  }
                }
                // On hover.
                $(this).mouseenter(function () {
                  $(this).css('color', '#df2f17');
                  $('#block-showhouse-map div[title=' + ($(this).find('input').val()) + ']').css('background', '#df2f17').css('border-radius', '50%');
                });
                // On hover out.
                $(this).mouseleave(function () {
                  if (!$(this).find('input').is(':checked')) {
                    $(this).css('color', '');
                    $('#block-showhouse-map div[title=' + ($(this).find('input').val()) + ']').css('background', '');
                  }
                });
              });

              // Unset one filter group, when another is selected.
              $(context).find('#views-exposed-form-showhouse-page-1 .js-form-type-radio').each(function (i, item) {
                $(this).find('input').on('click', function (e) {
                  if ($(this).attr('name') === 'maisons_temoins_filter' && $(this).val() !== 'All') {
                    $(context).find('#views-exposed-form-showhouse-page-1 .js-form-type-radio input[name=appartements_temoins_filter]').each(function (i, item) {
                      if ($(this).val() === 'All') {
                        $(this).prop('checked', true);
                      } else {
                        $(this).prop('checked', false)
                      }
                    });
                  }

                  if ($(this).attr('name') === 'appartements_temoins_filter' && $(this).val() !== 'All') {
                    $(context).find('#views-exposed-form-showhouse-page-1 .js-form-type-radio input[name=maisons_temoins_filter]').each(function (i, item) {
                      if ($(this).val() === 'All') {
                        $(this).prop('checked', true);
                      } else {
                        $(this).prop('checked', false)
                      }
                    });
                  }
                });
              });

            }
          });

        }
        // }}
      }
    })(jQuery);
